import script from "./EditorAbout.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorAbout.vue?vue&type=script&setup=true&lang=ts"

import "./EditorAbout.vue?vue&type=style&index=0&id=15346c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15346c60"]])

export default __exports__